import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34df96b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "每日成果跟进")
], -1))
const _hoisted_2 = { class: "tool-bar" }
const _hoisted_3 = { class: "static-content" }
const _hoisted_4 = { class: "static-content-item" }
const _hoisted_5 = { class: "static-number" }
const _hoisted_6 = { class: "static-number" }
const _hoisted_7 = { class: "static-content-item" }
const _hoisted_8 = { class: "static-number" }
const _hoisted_9 = { class: "static-number" }
const _hoisted_10 = { class: "static-number" }
const _hoisted_11 = { class: "static-number" }
const _hoisted_12 = { class: "static-content-item" }
const _hoisted_13 = { class: "static-number" }
const _hoisted_14 = {
  key: 0,
  class: "static-content-item"
}
const _hoisted_15 = { class: "static-number" }
const _hoisted_16 = { class: "static-number" }
const _hoisted_17 = {
  key: 1,
  class: "static-content-item"
}
const _hoisted_18 = { class: "static-number" }
const _hoisted_19 = { class: "static-number" }
const _hoisted_20 = { class: "static-number" }

import { onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { getListData } from '@/service/main/system'
import { ElLoading } from 'element-plus'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { useStore } from '@/store'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'DailyAchievement',
  setup(__props) {

dayjs.locale('zh-CN', {
  weekStart: 1
})

const store = useStore()
const userInfo = store.state.login.userInfo

const currentWeek: any = ref(null)
const weekDays: any = ref([
  { label: '周一' },
  { label: '周二' },
  { label: '周三' },
  { label: '周四' },
  { label: '周五' },
  { label: '周六' },
  { label: '周日' }
])

const activeName = ref(new Date().getDate())

const getWeekDates = (date: Date) => {
  // 调整到本周的周一
  const startOfWeek = new Date(
    date.setDate(date.getDate() - (date.getDay() || 7) + 1)
  )
  weekDays.value = [
    { label: '周一' },
    { label: '周二' },
    { label: '周三' },
    { label: '周四' },
    { label: '周五' },
    { label: '周六' },
    { label: '周日' }
  ]
  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek)
    date.setDate(date.getDate() + i)
    weekDays.value[i].day = date.getDate()
    weekDays.value[i].date = dayjs(date.toISOString()).format('YYYY-MM-DD')
  }
  return startOfWeek
}
let loadingInstance: ILoadingInstance = {} as ILoadingInstance
const getWeekData = (date: Date) => {
  loadingInstance = ElLoading.service({
    target: '.el-tabs__content'
  })
  const startOfWeek = new Date(
    date.setDate(date.getDate() - (date.getDay() || 7) + 1)
  )
  var endOfWeek = new Date(startOfWeek)
  endOfWeek.setDate(endOfWeek.getDate() + 6) // 加上6天得到周日
  getListData('/main/calendarEvents/dailyAchievement', {
    startDate: dayjs(startOfWeek.toISOString())
      .startOf('month')
      .format('YYYY-MM-DD'),
    endDate: dayjs(endOfWeek.toISOString()).endOf('month').format('YYYY-MM-DD'),
    pid: '1515974796226203648'
  }).then((res) => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    weekDays.value.forEach((item: any) => {
      const data = res.find((row: any) => item.date === row.date)
      Object.assign(item, data)
    })
  })
}

const isToday = (date: string) => {
  return dayjs(date).isSame(dayjs(), 'day')
}

const isAfterToday = (date: string | Date) => {
  return dayjs(date).isAfter(dayjs(), 'day')
}

const changeWeek = (val: Date) => {
  currentWeek.value = getWeekDates(val)
  activeName.value = val.getDate()
  getWeekData(val)
}

const handleClick = (tab: any, event: Event) => {
  console.log(tab, event)
}

const resourceApplyQy = () => {
  router.push({ path: '/main/report/customResourceApply' })
}

const resourceApply = () => {
  const reportUrl = router.resolve({
    path: '/main/report/customResourceApply/fill',
    query: {}
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.5
  const height = screenWidth * 0.5

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
}

onMounted(() => {
  const now = new Date()
  currentWeek.value = getWeekDates(now)
  getWeekData(now)
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { class: "card-container" }, {
    header: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_date_picker, {
          size: "mini",
          style: {"width":"110px"},
          onChange: changeWeek,
          modelValue: currentWeek.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentWeek).value = $event)),
          type: "week",
          "disabled-date": isAfterToday,
          format: "[第] ww [周]",
          placeholder: "选择周"
        }, null, 8, ["modelValue"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        stretch: "",
        type: "border-card",
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
        class: "week-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekDays.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              style: {"height":"100%"},
              key: index,
              disabled: isAfterToday(item.date),
              label: item.label,
              name: item.day
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label + ' ' + item.day), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" 计划沟通客户总数"),
                      _createElementVNode("i", _hoisted_5, _toDisplayString(item.total ? item.total : 0), 1),
                      _createTextVNode("，已与"),
                      _createElementVNode("i", _hoisted_6, _toDisplayString(item.commCount ? item.commCount : 0), 1),
                      _createTextVNode("个客户进行沟通 ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" 今日有效通话"),
                      _createElementVNode("i", _hoisted_8, _toDisplayString(item.voiceTotal ? item.voiceTotal : 0), 1),
                      _createTextVNode("次，累计通话时长"),
                      _createElementVNode("i", _hoisted_9, _toDisplayString(item.voiceTimeDuration ? item.voiceTimeDuration : 0), 1),
                      _createTextVNode("分钟， ")
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" 其中本月新资源有效通话"),
                      _createElementVNode("i", _hoisted_10, _toDisplayString(item.newResourceTotal ? item.newResourceTotal : 0), 1),
                      _createTextVNode("次，累计通话时长"),
                      _createElementVNode("i", _hoisted_11, _toDisplayString(item.newResourceTimeDuration ? item.newResourceTimeDuration : 0), 1),
                      _createTextVNode("分钟 ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createTextVNode(" 今日已填报成交"),
                      _createElementVNode("i", _hoisted_13, _toDisplayString(item.dealCount ? item.dealCount : 0), 1),
                      _createTextVNode("人 ")
                    ])
                  ]),
                  (_unref(userInfo).empTag === '0')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" 资金量核实填报总数"),
                          _createElementVNode("i", _hoisted_15, _toDisplayString(item.reportCount ? item.reportCount : 0), 1),
                          _createTextVNode("，已核实"),
                          _createElementVNode("i", _hoisted_16, _toDisplayString(item.verifyCount ? item.verifyCount : 0), 1),
                          _createTextVNode("个 ")
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (item.newResource)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _createTextVNode(" 本月接入新资源"),
                          _createElementVNode("i", _hoisted_18, _toDisplayString(item.newResource ? item.newResource : 0), 1),
                          _createTextVNode("人，已删除"),
                          _createElementVNode("i", _hoisted_19, _toDisplayString(item.delResource ? item.delResource : 0), 1),
                          _createTextVNode("人，已备注成交"),
                          _createElementVNode("i", _hoisted_20, _toDisplayString(item.billingNewResource ? item.billingNewResource : 0), 1),
                          _createTextVNode("人 ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["disabled", "label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})